import { ValidEmail } from '@invoice-simple/domain-invoicing';

const hasMisplacedDotInLocalPart = (email: string): boolean => {
  const localPart = email.slice(0, email.lastIndexOf('@'));
  return localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..');
};

export const isValidEmail = (email?: string): boolean => {
  if (typeof email !== 'string') return false;

  const trimmedEmail = email.trim();
  return ValidEmail.is(trimmedEmail) && !hasMisplacedDotInLocalPart(trimmedEmail);
};
